import { useState, useEffect } from 'react';
import { URL } from '@ux/util';

/**
 * Get page configuration from `target.ux`, usually the window.
 *
 * @param {Window|Object} target Browser window object or fallback
 * @returns {Object} page configuration.
 * @public
 */
export function usePageConfig(target = {}) {
  const [config, setConfig] = useState({});

  useEffect(() => {
    const ux = target.ux;
    setConfig(ux.page || ux.eldorado.page);
  }, []);

  return config;
}

/**
 * Get orderId from the querystring parameters.
 *
 * @param {Window|Object} target Browser window object or fallback
 * @returns {Object} order id.
 * @public
 */
export function useOrderDetails(target = {}) {
  const [orderId, setOrderId] = useState(null);

  useEffect(() => {
    const href = target.location.href;
    if (!href) return;
    const { orderId } = new URL(href, true).query;

    setOrderId(orderId);
  }, []);

  return orderId;
}
